import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { DocumentRequirement } from 'components/Signup/TradingHistory/DocumentRequirement/DocumentRequirement';
import { TOfferDataRequirement } from 'lendingApi/lapiOverrides.types';
import sharedStyles from '../DocumentRequirements.module.css';

type TProps = {
  isOptional: boolean;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};

export const BwaSusaAnnual = ({ isOptional, isSubmitted, status }: TProps) => {
  return (
    <DocumentRequirement
      title={t`BWAs and SuSas from the last 2 years`}
      documentType="year end management and balance accounts"
      isOptional={isOptional}
      isSubmitted={isSubmitted}
      status={status}
    >
      <>
        <ul>
          <li>
            <Trans>
              All BWAs should show company name, sales revenue, purchases of
              goods, costs including depreciation, interest expenses &
              preliminary results
            </Trans>
          </li>
          <li>
            <Trans>
              All SuSas should include EB value, cumulative annual values &
              balance and be submitted in the correct format
            </Trans>
          </li>
        </ul>

        <h4 className={sharedStyles.subTitle}>
          <Trans>Example SuSa format Datev:</Trans>
        </h4>
        <ul>
          <li>
            <Trans>
              Correct: all posted accounts or general ledger accounts
            </Trans>
          </li>
          <li>
            <Trans>
              Incorrect: individual batch, accounts without zero balances
            </Trans>
          </li>
        </ul>
      </>
    </DocumentRequirement>
  );
};
